import React from 'react'
import { Link } from 'react-router-dom'

import { Heading, PageLoader, Table } from 'component-library-next'
import moment from 'moment'

import { getName } from '@app/common/helpers/getName'
import { getMessagesPath } from '@app/modules/Messages'
import { useLawyerCustomerInteractionsQuery } from '@app/queries/LawyerCustomerInteractions/LawyerCustomerInteractions.queries'

export function LatestInteractionsTable() {
  const { data, loading } = useLawyerCustomerInteractionsQuery({
    variables: { limit: 50 },
    fetchPolicy: 'network-only'
  })

  if (loading) {
    return <PageLoader loading />
  }

  const columns = [
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Thema',
      accessor: 'topic'
    },
    {
      Header: 'Termin',
      accessor: 'appointment'
    },
    {
      Header: 'Beantwortet am',
      accessor: 'latestInteraction'
    }
  ]

  return (
    <>
      <Heading size={Heading.sizes.medium}>
        <span>Letzte Beratungen</span>
      </Heading>
      <Table
        columns={columns}
        data={
          data
            ? data.lawyerCustomerInteractions.map((interaction) => ({
                name: <span aria-label='Name'>{getName(interaction.customer)}</span>,
                topic: (
                  <Link to={getMessagesPath(interaction.customer.id)}>{interaction.topicName}</Link>
                ),
                appointment: interaction.latestAppointmentDate
                  ? moment(interaction.latestAppointmentDate).format('DD.MM, HH:mm')
                  : '',
                latestInteraction: moment(interaction.updatedAt).format('DD.MM, HH:mm')
              }))
            : []
        }
      />
    </>
  )
}
